angular.module('navigationPaneModule', []);
